import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
  GestureConfig, MatToolbarModule, MatInputModule, MatButtonModule, MatStepperModule,
  MatSelectModule, MatCheckboxModule, MatExpansionModule, MatSnackBarModule, MatChipsModule,
  MatRadioModule, MatTooltipModule, MatDialogModule
} from '@angular/material';

import {AppComponent} from './app.component';
import {CheckoutComponent} from './checkout/checkout.component';
import {CheckoutService} from './services/checkout.service';
import {AppRoutingModule} from './app-routing.module';
import {ParticipateComponent} from './participate/participate.component';
import {CheckoutParamsGuard} from './guards/checkout-params.guard';
import {CurrencyMaskModule} from 'ngx-currency-mask';
import {CardModule} from 'ngx-card/ngx-card';
import {ShareButtonsModule} from '@ngx-share/buttons';
import {ParticipateService} from './services/participate.service';
import {ShareComponent} from './share/share.component';
import {TestCheckoutComponent} from './test-checkout/test-checkout.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {ParticipateResponseComponent} from './participate-response/participate-response.component';
import {CustomerService} from "./services/customer.service";
import {NgHttpLoaderServicesModule} from "ng-http-loader/services/ng-http-loader-services.module";
import {NgHttpLoaderComponentsModule} from "ng-http-loader/components/ng-http-loader-components.module";
import {DialogErrorComponent} from './dialog-error/dialog-error.component';

@NgModule({
  declarations: [
    AppComponent,
    CheckoutComponent,
    ParticipateComponent,
    ShareComponent,
    TestCheckoutComponent,
    NotFoundComponent,
    ParticipateResponseComponent,
    DialogErrorComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    CurrencyMaskModule,
    CardModule,
    ShareButtonsModule.forRoot(),
    NgHttpLoaderServicesModule,
    NgHttpLoaderComponentsModule,
    MatToolbarModule,
    MatInputModule,
    MatButtonModule,
    MatStepperModule,
    MatSelectModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatChipsModule,
    MatRadioModule,
    MatTooltipModule,
    MatDialogModule
  ],
  providers: [
    CheckoutService,
    ParticipateService,
    CustomerService,
    CheckoutParamsGuard,
    {provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig},

  ],
  entryComponents: [
    DialogErrorComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts